import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
	isLocked: boolean;
	onLockClick: (isLocked: boolean) => void;
}

const InputLockButton = (props: IProps) => {
	return (
		<span
			className="input-group-text input-label-field-button"
			onClick={() => props.onLockClick(!props.isLocked)}
		>
			{props.isLocked ? (
				<FontAwesomeIcon icon={faLock} style={{ color: '#999' }} />
			) : (
				<FontAwesomeIcon icon={faUnlock} style={{ color: '#999' }} />
			)}
		</span>
	);
};

export default InputLockButton;
